/**
 * Labstep
 *
 * @module components/Organization/Header
 * @desc Organization Header component
 */

import { OrganizationLogo } from 'labstep-web/components/Organization/Logo';
import { Header } from 'labstep-web/core/Header';
import type React from 'react';
import styles from './styles.module.scss';
import type { OrganizationHeaderProps } from './types';

export const OrganizationHeader: React.FC<
  OrganizationHeaderProps
> = ({ organization, size }) => (
  <div className={styles.container}>
    <OrganizationLogo organization={organization} size={size} />
    <Header isDataPublic={false}>{organization.name}</Header>
  </div>
);
